// // D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\AdminPerformance.js

// import React, {
//   useEffect,
//   useMemo,
//   useState
// } from "react";

// import axios from "axios";

// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   CartesianGrid,
//   XAxis,
//   YAxis,
//   Tooltip,
//   AreaChart,
//   Area,
//   PieChart,
//   Pie,
//   Cell
// } from "recharts";

// import {
//   FaUserShield,
//   FaChartLine,
//   FaCheckCircle,
//   FaClock,
//   FaExclamationTriangle,
//   FaFire,
//   FaLayerGroup,
//   FaSyncAlt,
//   FaBolt,
//   FaBrain,
//   FaShieldAlt,
//   FaUserTie,
//   FaArrowUp,
//   FaArrowDown,
//   FaStar,
//   FaTrophy,
//   FaTasks,
//   FaUsersCog,
//   FaBell
// } from "react-icons/fa";

// // import "./AdminPerformance.css";
// import "./Support.css";

// const API =
//   "https://api.mahal.qa/api/v1/admin/support";

// const CHART_COLORS = [
//   "#f97316",
//   "#fb923c",
//   "#fdba74",
//   "#f59e0b",
//   "#facc15"
// ];

// export default function AdminPerformance() {

//   const token =
//     localStorage.getItem(
//       "admin_token"
//     );

//   const [loading, setLoading] =
//     useState(true);

//   const [refreshing, setRefreshing] =
//     useState(false);

//   const [performance, setPerformance] =
//     useState([]);

//   const [admins, setAdmins] =
//     useState([]);

//   const [tickets, setTickets] =
//     useState([]);

//   const [dashboard, setDashboard] =
//     useState({});

//   const [slaBreached, setSlaBreached] =
//     useState([]);

//   /* ========================================================
//      FETCH
//   ======================================================== */

//   const fetchPerformance =
//     async (manual = false) => {

//       try {

//         if (manual) {
//           setRefreshing(true);
//         } else {
//           setLoading(true);
//         }

//         const headers = {
//           Authorization: `Bearer ${token}`
//         };

//         const [
//           performanceRes,
//           adminsRes,
//           ticketsRes,
//           dashboardRes,
//           slaRes
//         ] = await Promise.all([

//           axios.get(
//             `${API}/admin-performance`,
//             { headers }
//           ),

//           axios.get(
//             `${API}/admins`,
//             { headers }
//           ),

//           axios.get(
//             `${API}/tickets`,
//             {
//               headers,
//               params: {
//                 limit: 250
//               }
//             }
//           ),

//           axios.get(
//             `${API}/dashboard`,
//             { headers }
//           ),

//           axios.get(
//             `${API}/sla-breached`,
//             { headers }
//           )

//         ]);

//         setPerformance(
//           performanceRes.data || []
//         );

//         setAdmins(
//           adminsRes.data || []
//         );

//         setTickets(
//           ticketsRes.data?.data || []
//         );

//         setDashboard(
//           dashboardRes.data || {}
//         );

//         setSlaBreached(
//           slaRes.data || []
//         );

//       } catch (error) {

//         console.error(
//           "Performance dashboard failed",
//           error
//         );

//       } finally {

//         setLoading(false);
//         setRefreshing(false);
//       }
//     };

//   useEffect(() => {

//     fetchPerformance();

//     const interval =
//       setInterval(() => {

//         fetchPerformance();

//       }, 30000);

//     return () =>
//       clearInterval(interval);

//   }, []);

//   /* ========================================================
//      ANALYTICS
//   ======================================================== */

//   const rankedAdmins =
//     useMemo(() => {

//       return [...performance]
//         .sort((a, b) => {

//           const aScore =
//             (a.resolved || 0) * 2 -
//             (a.pending || 0);

//           const bScore =
//             (b.resolved || 0) * 2 -
//             (b.pending || 0);

//           return bScore - aScore;
//         })
//         .map((admin, index) => ({
//           ...admin,
//           rank: index + 1,
//           score:
//             (admin.resolved || 0) *
//               2 -
//             (admin.pending || 0)
//         }));

//     }, [performance]);

//   const topAdmins =
//     rankedAdmins.slice(0, 5);

//   const lowPerformanceAdmins =
//     rankedAdmins
//       .filter(
//         (admin) =>
//           (admin.pending || 0) >
//           (admin.resolved || 0)
//       )
//       .slice(0, 5);

//   const totalResolved =
//     performance.reduce(
//       (sum, admin) =>
//         sum +
//         (admin.resolved || 0),
//       0
//     );

//   const totalPending =
//     performance.reduce(
//       (sum, admin) =>
//         sum +
//         (admin.pending || 0),
//       0
//     );

//   const avgResolutionTime =
//     performance.length
//       ? (
//           performance.reduce(
//             (sum, admin) =>
//               sum +
//               Number(
//                 admin.avg_resolution_hours ||
//                   0
//               ),
//             0
//           ) /
//           performance.length
//         ).toFixed(1)
//       : 0;

//   const performanceTrend =
//     useMemo(() => {

//       return rankedAdmins
//         .slice(0, 7)
//         .map((admin) => ({
//           name:
//             admin.name?.split(
//               " "
//             )[0],
//           resolved:
//             admin.resolved || 0,
//           pending:
//             admin.pending || 0,
//           breached:
//             admin.sla_breached_open ||
//             0
//         }));

//     }, [rankedAdmins]);

//   const queueLoad =
//     useMemo(() => {

//       const grouped = {};

//       rankedAdmins.forEach(
//         (admin) => {

//           const queue =
//             admin.queue_name ||
//             "Unknown";

//           grouped[queue] =
//             (grouped[queue] || 0) +
//             (admin.pending || 0);

//         }
//       );

//       return Object.keys(grouped).map(
//         (key) => ({
//           name: key,
//           value: grouped[key]
//         })
//       );

//     }, [rankedAdmins]);

//   const efficiencyPie =
//     useMemo(() => [

//       {
//         name: "Resolved",
//         value: totalResolved
//       },

//       {
//         name: "Pending",
//         value: totalPending
//       },

//       {
//         name: "Breached",
//         value:
//           slaBreached.length
//       }

//     ], [
//       totalResolved,
//       totalPending,
//       slaBreached
//     ]);

//   /* ========================================================
//      SUMMARY
//   ======================================================== */

//   const summaryCards = [

//     {
//       title: "Active Admins",
//       value:
//         admins.length,
//       icon: <FaUsersCog />,
//       className: "primary"
//     },

//     {
//       title: "Resolved Tickets",
//       value:
//         totalResolved,
//       icon: <FaCheckCircle />,
//       className: "success"
//     },

//     {
//       title: "Pending Load",
//       value:
//         totalPending,
//       icon: <FaTasks />,
//       className: "warning"
//     },

//     {
//       title: "SLA Breaches",
//       value:
//         slaBreached.length,
//       icon:
//         <FaExclamationTriangle />,
//       className: "danger"
//     },

//     {
//       title: "Avg Resolution",
//       value:
//         `${avgResolutionTime}h`,
//       icon: <FaClock />,
//       className: "info"
//     },

//     {
//       title: "Open Tickets",
//       value:
//         dashboard.open || 0,
//       icon: <FaFire />,
//       className: "critical"
//     }

//   ];

//   /* ========================================================
//      LOADING
//   ======================================================== */

//   if (loading) {

//     return (

//       <div className="adminperf_loader_screen">

//         <div className="adminperf_loader_box">

//           <div className="adminperf_loader_ring"></div>

//           <h2>
//             Loading Workforce Analytics
//           </h2>

//           <p>
//             Building enterprise admin
//             intelligence...
//           </p>

//         </div>

//       </div>
//     );
//   }

//   /* ========================================================
//      RENDER
//   ======================================================== */

//   return (

//     <div className="adminperf_page">

//       {/* ====================================================
//          HEADER
//       ==================================================== */}

//       <div className="adminperf_header">

//         <div>

//           <div className="adminperf_live_tag">

//             <span></span>

//             ENTERPRISE PERFORMANCE CORE

//           </div>

//           <h1>
//             Admin Workforce Intelligence
//           </h1>

//           <p>
//             Real-time productivity,
//             SLA efficiency, ticket
//             ownership & operational
//             performance monitoring
//           </p>

//         </div>

//         <button
//           className={`adminperf_refresh_btn ${
//             refreshing
//               ? "adminperf_refreshing"
//               : ""
//           }`}
//           onClick={() =>
//             fetchPerformance(
//               true
//             )
//           }
//         >

//           <FaSyncAlt />

//           Refresh Analytics

//         </button>

//       </div>

//       {/* ====================================================
//          SUMMARY
//       ==================================================== */}

//       <div className="adminperf_summary_grid">

//         {summaryCards.map(
//           (card, index) => (

//             <div
//               key={index}
//               className={`adminperf_summary_card ${card.className}`}
//             >

//               <div className="adminperf_summary_icon">
//                 {card.icon}
//               </div>

//               <div>

//                 <h3>
//                   {card.value}
//                 </h3>

//                 <p>
//                   {card.title}
//                 </p>

//               </div>

//             </div>

//           )
//         )}

//       </div>

//       {/* ====================================================
//          HERO GRID
//       ==================================================== */}

//       <div className="adminperf_hero_grid">

//         {/* ================================================
//            TOP PERFORMERS
//         ================================================ */}

//         <div className="adminperf_card">

//           <div className="adminperf_card_header">

//             <div>

//               <span>
//                 PERFORMANCE RANKING
//               </span>

//               <h3>
//                 Elite Admin Operators
//               </h3>

//             </div>

//             <FaTrophy />

//           </div>

//           <div className="adminperf_top_list">

//             {topAdmins.map(
//               (admin) => (

//                 <div
//                   key={
//                     admin.admin_id
//                   }
//                   className="adminperf_top_row"
//                 >

//                   <div className="adminperf_rank">

//                     #{admin.rank}

//                   </div>

//                   <div className="adminperf_admin_info">

//                     <div className="adminperf_avatar">

//                       <FaUserTie />

//                     </div>

//                     <div>

//                       <h4>
//                         {admin.name}
//                       </h4>

//                       <p>
//                         {
//                           admin.queue_name
//                         }
//                       </p>

//                     </div>

//                   </div>

//                   <div className="adminperf_score_box">

//                     <strong>
//                       {
//                         admin.score
//                       }
//                     </strong>

//                     <span>
//                       Score
//                     </span>

//                   </div>

//                 </div>

//               )
//             )}

//           </div>

//         </div>

//         {/* ================================================
//            AI ANALYTICS
//         ================================================ */}

//         <div className=" adminperf_card ">

//           <div className="adminperf_ai_header">

//             <div>

//               <span>
//                 AI WORKFORCE ANALYZER
//               </span>

//               <h2>
//                 {
//                   rankedAdmins.length
//                 }
//               </h2>

//             </div>

//             <FaBrain />

//           </div>

//           <div className="adminperf_ai_metrics">

//             <div>

//               <strong>
//                 {
//                   totalResolved
//                 }
//               </strong>

//               <p>
//                 Total Resolved
//               </p>

//             </div>

//             <div>

//               <strong>
//                 {
//                   slaBreached.length
//                 }
//               </strong>

//               <p>
//                 SLA Risks
//               </p>

//             </div>

//             <div>

//               <strong>
//                 {
//                   avgResolutionTime
//                 }
//                 h
//               </strong>

//               <p>
//                 Avg Resolution
//               </p>

//             </div>

//           </div>

//           <div className="adminperf_ai_status">

//             <FaShieldAlt />

//             Workforce operating at
//             enterprise productivity
//             stability
//           </div>

//         </div>

//       </div>

//       {/* ====================================================
//          CHART GRID
//       ==================================================== */}

//       <div className="adminperf_chart_grid">

//         {/* ================================================
//            TREND
//         ================================================ */}

//         <div className="adminperf_card">

//           <div className="adminperf_card_header">

//             <div>

//               <span>
//                 PRODUCTIVITY GRAPH
//               </span>

//               <h3>
//                 Resolution Efficiency
//               </h3>

//             </div>

//             <FaChartLine />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={350}
//           >

//             <AreaChart
//               data={
//                 performanceTrend
//               }
//             >

//               <defs>

//                 <linearGradient
//                   id="adminPerfGradient"
//                   x1="0"
//                   y1="0"
//                   x2="0"
//                   y2="1"
//                 >

//                   <stop
//                     offset="5%"
//                     stopColor="#f97316"
//                     stopOpacity={0.7}
//                   />

//                   <stop
//                     offset="95%"
//                     stopColor="#f97316"
//                     stopOpacity={0}
//                   />

//                 </linearGradient>

//               </defs>

//               <CartesianGrid
//                 strokeDasharray="3 3"
//               />

//               <XAxis
//                 dataKey="name"
//               />

//               <YAxis />

//               <Tooltip />

//               <Area
//                 type="monotone"
//                 dataKey="resolved"
//                 stroke="#f97316"
//                 fillOpacity={1}
//                 fill="url(#adminPerfGradient)"
//               />

//             </AreaChart>

//           </ResponsiveContainer>

//         </div>

//         {/* ================================================
//            EFFICIENCY PIE
//         ================================================ */}

//         <div className="adminperf_card">

//           <div className="adminperf_card_header">

//             <div>

//               <span>
//                 WORKLOAD HEALTH
//               </span>

//               <h3>
//                 Ticket Distribution
//               </h3>

//             </div>

//             <FaBolt />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={350}
//           >

//             <PieChart>

//               <Pie
//                 data={
//                   efficiencyPie
//                 }
//                 dataKey="value"
//                 outerRadius={110}
//                 label
//               >

//                 {efficiencyPie.map(
//                   (
//                     item,
//                     index
//                   ) => (

//                     <Cell
//                       key={index}
//                       fill={
//                         CHART_COLORS[
//                           index
//                         ]
//                       }
//                     />

//                   )
//                 )}

//               </Pie>

//               <Tooltip />

//             </PieChart>

//           </ResponsiveContainer>

//         </div>

//       </div>

//       {/* ====================================================
//          LOWER GRID
//       ==================================================== */}

//       <div className="adminperf_lower_grid">

//         {/* ================================================
//            QUEUE LOAD
//         ================================================ */}

//         <div className="adminperf_card">

//           <div className="adminperf_card_header">

//             <div>

//               <span>
//                 QUEUE WORKLOAD
//               </span>

//               <h3>
//                 Queue Pressure Matrix
//               </h3>

//             </div>

//             <FaLayerGroup />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={330}
//           >

//             <BarChart
//               data={queueLoad}
//             >

//               <CartesianGrid
//                 strokeDasharray="3 3"
//               />

//               <XAxis
//                 dataKey="name"
//               />

//               <YAxis />

//               <Tooltip />

//               <Bar
//                 dataKey="value"
//                 fill="#fb923c"
//               />

//             </BarChart>

//           </ResponsiveContainer>

//         </div>

//         {/* ================================================
//            RISK ADMINS
//         ================================================ */}

//         <div className="adminperf_card">

//           <div className="adminperf_card_header">

//             <div>

//               <span>
//                 RISK DETECTION
//               </span>

//               <h3>
//                 Escalation Risk Admins
//               </h3>

//             </div>

//             <FaBell />

//           </div>

//           <div className="adminperf_risk_list">

//             {lowPerformanceAdmins.map(
//               (admin) => (

//                 <div
//                   key={
//                     admin.admin_id
//                   }
//                   className="adminperf_risk_row"
//                 >

//                   <div className="adminperf_risk_left">

//                     <div className="adminperf_risk_avatar">

//                       <FaExclamationTriangle />

//                     </div>

//                     <div>

//                       <h4>
//                         {admin.name}
//                       </h4>

//                       <p>
//                         {
//                           admin.queue_name
//                         }
//                       </p>

//                     </div>

//                   </div>

//                   <div className="adminperf_risk_metrics">

//                     <span>

//                       <FaArrowDown />

//                       {
//                         admin.pending
//                       }
//                       {" "}
//                       Pending

//                     </span>

//                     <span>

//                       <FaArrowUp />

//                       {
//                         admin.resolved
//                       }
//                       {" "}
//                       Resolved

//                     </span>

//                   </div>

//                 </div>

//               )
//             )}

//           </div>

//         </div>

//       </div>

//       {/* ====================================================
//          TABLE
//       ==================================================== */}

//       <div className="adminperf_table_panel">

//         <div className="adminperf_card_header">

//           <div>

//             <span>
//               ENTERPRISE WORKFORCE MATRIX
//             </span>

//             <h3>
//               Real-Time Admin Performance
//             </h3>

//           </div>

//           <FaUserShield />

//         </div>

//         <div className="adminperf_table_wrapper">

//           <table className="adminperf_table">

//             <thead>

//               <tr>

//                 <th>
//                   Rank
//                 </th>

//                 <th>
//                   Admin
//                 </th>

//                 <th>
//                   Queue
//                 </th>

//                 <th>
//                   Resolved
//                 </th>

//                 <th>
//                   Pending
//                 </th>

//                 <th>
//                   Resolution Rate
//                 </th>

//                 <th>
//                   Avg Hours
//                 </th>

//                 <th>
//                   SLA Risks
//                 </th>

//               </tr>

//             </thead>

//             <tbody>

//               {rankedAdmins.map(
//                 (admin) => (

//                   <tr
//                     key={
//                       admin.admin_id
//                     }
//                   >

//                     <td>

//                       <span className="adminperf_rank_badge">

//                         #{admin.rank}

//                       </span>

//                     </td>

//                     <td>

//                       <div className="adminperf_table_admin">

//                         <div className="adminperf_table_avatar">

//                           <FaStar />

//                         </div>

//                         <div>

//                           <strong>
//                             {
//                               admin.name
//                             }
//                           </strong>

//                           <span>
//                             {
//                               admin.email
//                             }
//                           </span>

//                         </div>

//                       </div>

//                     </td>

//                     <td>
//                       {
//                         admin.queue_name
//                       }
//                     </td>

//                     <td>

//                       <span className="adminperf_success_badge">

//                         {
//                           admin.resolved
//                         }

//                       </span>

//                     </td>

//                     <td>

//                       <span className="adminperf_pending_badge">

//                         {
//                           admin.pending
//                         }

//                       </span>

//                     </td>

//                     <td>

//                       {Number(
//                         admin.resolution_rate ||
//                           0
//                       ).toFixed(1)}
//                       %

//                     </td>

//                     <td>

//                       {Number(
//                         admin.avg_resolution_hours ||
//                           0
//                       ).toFixed(1)}
//                       h

//                     </td>

//                     <td>

//                       <span className="adminperf_risk_badge">

//                         {
//                           admin.sla_breached_open
//                         }

//                       </span>

//                     </td>

//                   </tr>

//                 )
//               )}

//             </tbody>

//           </table>

//         </div>

//       </div>

//     </div>
//   );
// }



// D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\AdminPerformance.js

import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import axios from "axios";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell
} from "recharts";

import {
  FaUserShield,
  FaChartLine,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
  FaFire,
  FaLayerGroup,
  FaSyncAlt,
  FaBolt,
  FaBrain,
  FaShieldAlt,
  FaUserTie,
  FaArrowUp,
  FaArrowDown,
  FaStar,
  FaTrophy,
  FaTasks,
  FaUsersCog,
  FaBell
} from "react-icons/fa";

// import "./AdminPerformance.css";
import "./Support.css";

const API =
  "https://api.mahal.qa/api/v1/admin/support";

const CHART_COLORS = [
  "#f97316",
  "#fb923c",
  "#fdba74",
  "#f59e0b",
  "#facc15"
];

export default function AdminPerformance() {

  const token =
    localStorage.getItem(
      "admin_token"
    );

  const [loading, setLoading] =
    useState(true);

  const [refreshing, setRefreshing] =
    useState(false);

  const [performance, setPerformance] =
    useState([]);

  const [admins, setAdmins] =
    useState([]);

  const [tickets, setTickets] =
    useState([]);

  const [dashboard, setDashboard] =
    useState({});

  const [slaBreached, setSlaBreached] =
    useState([]);

  /* ========================================================
     FETCH
  ======================================================== */

  const fetchPerformance =
    async (manual = false) => {

      try {

        if (manual) {
          setRefreshing(true);
        } else {
          setLoading(true);
        }

        const headers = {
          Authorization: `Bearer ${token}`
        };

        const [
          performanceRes,
          adminsRes,
          ticketsRes,
          dashboardRes,
          slaRes
        ] = await Promise.all([

          axios.get(
            `${API}/admin-performance`,
            { headers }
          ),

          axios.get(
            `${API}/admins`,
            { headers }
          ),

          axios.get(
            `${API}/tickets`,
            {
              headers,
              params: {
                limit: 250
              }
            }
          ),

          axios.get(
            `${API}/dashboard`,
            { headers }
          ),

          axios.get(
            `${API}/sla-breached`,
            { headers }
          )

        ]);

        setPerformance(
          performanceRes.data || []
        );

        setAdmins(
          adminsRes.data || []
        );

        setTickets(
          ticketsRes.data?.data || []
        );

        setDashboard(
          dashboardRes.data || {}
        );

        setSlaBreached(
          slaRes.data || []
        );

      } catch (error) {

        console.error(
          "Performance dashboard failed",
          error
        );

      } finally {

        setLoading(false);
        setRefreshing(false);
      }
    };

  useEffect(() => {

    fetchPerformance();

    const interval =
      setInterval(() => {

        fetchPerformance();

      }, 30000000);

    return () =>
      clearInterval(interval);

  }, []);

  /* ========================================================
     ANALYTICS
  ======================================================== */

  const rankedAdmins =
    useMemo(() => {

      return [...performance]
        .sort((a, b) => {

          const aScore =
            (a.resolved || 0) * 2 -
            (a.pending || 0);

          const bScore =
            (b.resolved || 0) * 2 -
            (b.pending || 0);

          return bScore - aScore;
        })
        .map((admin, index) => ({
          ...admin,
          rank: index + 1,
          score:
            (admin.resolved || 0) *
            2 -
            (admin.pending || 0)
        }));

    }, [performance]);

  const topAdmins =
    rankedAdmins.slice(0, 5);

  const lowPerformanceAdmins =
    rankedAdmins
      .filter(
        (admin) =>
          (admin.pending || 0) >
          (admin.resolved || 0)
      )
      .slice(0, 5);

  const totalResolved =
    performance.reduce(
      (sum, admin) =>
        sum +
        (admin.resolved || 0),
      0
    );

  const totalPending =
    performance.reduce(
      (sum, admin) =>
        sum +
        (admin.pending || 0),
      0
    );

  const avgResolutionTime =
    performance.length
      ? (
        performance.reduce(
          (sum, admin) =>
            sum +
            Number(
              admin.avg_resolution_hours ||
              0
            ),
          0
        ) /
        performance.length
      ).toFixed(1)
      : 0;

  const performanceTrend =
    useMemo(() => {

      return rankedAdmins
        .slice(0, 7)
        .map((admin) => ({
          name:
            admin.name?.split(
              " "
            )[0],
          resolved:
            admin.resolved || 0,
          pending:
            admin.pending || 0,
          breached:
            admin.sla_breached_open ||
            0
        }));

    }, [rankedAdmins]);

  const queueLoad =
    useMemo(() => {

      const grouped = {};

      rankedAdmins.forEach(
        (admin) => {

          const queue =
            admin.queue_name ||
            "Unknown";

          grouped[queue] =
            (grouped[queue] || 0) +
            (admin.pending || 0);

        }
      );

      return Object.keys(grouped).map(
        (key) => ({
          name: key,
          value: grouped[key]
        })
      );

    }, [rankedAdmins]);

  const efficiencyPie =
    useMemo(() => [

      {
        name: "Resolved",
        value: totalResolved
      },

      {
        name: "Pending",
        value: totalPending
      },

      {
        name: "Breached",
        value:
          slaBreached.length
      }

    ], [
      totalResolved,
      totalPending,
      slaBreached
    ]);

  /* ========================================================
     SUMMARY
  ======================================================== */

  const summaryCards = [

    {
      title: "Active Admins",
      value:
        admins.length,
      icon: <FaUsersCog />,
      className: "primary"
    },

    {
      title: "Resolved Tickets",
      value:
        totalResolved,
      icon: <FaCheckCircle />,
      className: "success"
    },

    {
      title: "Pending Load",
      value:
        totalPending,
      icon: <FaTasks />,
      className: "warning"
    },

    {
      title: "SLA Breaches",
      value:
        slaBreached.length,
      icon:
        <FaExclamationTriangle />,
      className: "danger"
    },

    {
      title: "Avg Resolution",
      value:
        `${avgResolutionTime}h`,
      icon: <FaClock />,
      className: "info"
    },

    {
      title: "Open Tickets",
      value:
        dashboard.open || 0,
      icon: <FaFire />,
      className: "critical"
    }

  ];

  /* ========================================================
     LOADING
  ======================================================== */

  if (loading) {

    return (

      <div className="support-loader">
        <div className="support-loader-card">
          <div className="support-loader-ring"></div>

          <h2>
            Loading Workforce Analytics
          </h2>

          <p>
            Building enterprise admin
            intelligence...
          </p>

        </div>

      </div>
    );
  }

  /* ========================================================
     RENDER
  ======================================================== */

  return (

    <div className="support-page">

      {/* ====================================================
         HEADER
      ==================================================== */}

      <div className="support-header">

        <div className="support-header-content">

          <div className="support-live-tag">
            <span className="support-live-dot"></span>

            ENTERPRISE PERFORMANCE CORE

          </div>

          <h1>
            Admin Workforce Intelligence
          </h1>

          <p>
            Real-time productivity,
            SLA efficiency, ticket
            ownership & operational
            performance monitoring
          </p>

        </div>

        <button
          className={`support-refresh-btn ${refreshing
              ? "support-refreshing"
              : ""
            }`}
          onClick={() =>
            fetchPerformance(
              true
            )
          }
        >

          <FaSyncAlt />

        </button>

      </div>

      {/* ====================================================
         SUMMARY
      ==================================================== */}

      <div className="support-summary-grid">

        {summaryCards.map(
          (card, index) => (

            <div
              key={index}
              className={`support-summary-card is-${card.className}`}
            >

              <div className="support-summary-icon">
                {card.icon}
              </div>

              <div className="support-summary-meta">

                <h3>
                  {card.value}
                </h3>

                <p>
                  {card.title}
                </p>

              </div>

            </div>

          )
        )}

      </div>

      {/* ====================================================
         HERO GRID
      ==================================================== */}

      <div className="support-panel-grid">

        {/* ================================================
           TOP PERFORMERS
        ================================================ */}

        <div className="support-panel support-panel--mid">

          <div className="support-panel-header">

            <div className="support-panel-title">

              <span>
                PERFORMANCE RANKING
              </span>

              <h3>
                Elite Admin Operators
              </h3>

            </div>

            <FaTrophy />

          </div>

          <div className="support-top-list">

            {topAdmins.map(
              (admin) => (

                <div
                  key={
                    admin.admin_id
                  }
                  className="support-top-row"
                >

                  <div className="support-rank">

                    #{admin.rank}

                  </div>

                  <div className="support-user-info">

                    <div className="support-avatar">

                      <FaUserTie />

                    </div>

                    <div>

                      <h4>
                        {admin.name}
                      </h4>

                      <p>
                        {
                          admin.queue_name
                        }
                      </p>

                    </div>

                  </div>

                  <div className="support-score-box">

                    <strong>
                      {
                        admin.score
                      }
                    </strong>

                    <span>
                      Score
                    </span>

                  </div>

                </div>

              )
            )}

          </div>

        </div>

        {/* ================================================
           AI ANALYTICS
        ================================================ */}

        <div className=" support-panel ">

          <div className="support-ai-header">

            <div>

              <span>
                AI WORKFORCE ANALYZER
              </span>

              <h2>
                {
                  rankedAdmins.length
                }
              </h2>

            </div>

            <FaBrain />

          </div>

          <div className="support-ai-metrics">

            <div>

              <strong>
                {
                  totalResolved
                }
              </strong>

              <p>
                Total Resolved
              </p>

            </div>

            <div>

              <strong>
                {
                  slaBreached.length
                }
              </strong>

              <p>
                SLA Risks
              </p>

            </div>

            <div>

              <strong>
                {
                  avgResolutionTime
                }
                h
              </strong>

              <p>
                Avg Resolution
              </p>

            </div>

          </div>

          <div className="adminperf-ai-status">

            <FaShieldAlt />

            Workforce operating at
            enterprise productivity
            stability
          </div>

        </div>

      </div>

      {/* ====================================================
         CHART GRID
      ==================================================== */}

      <div className="support-chart-grid">

        {/* ================================================
           TREND
        ================================================ */}

        <div className="support-panel support-panel--mid">

          <div className="support-panel-header">

            <div>

              <span>
                PRODUCTIVITY GRAPH
              </span>

              <h3>
                Resolution Efficiency
              </h3>

            </div>

            <FaChartLine />

          </div>

          <ResponsiveContainer
            width="100%"
            height={350}
          >

            <AreaChart
              data={
                performanceTrend
              }
            >

              <defs>

                <linearGradient
                  id="adminPerfGradient"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >

                  <stop
                    offset="5%"
                    stopColor="#f97316"
                    stopOpacity={0.7}
                  />

                  <stop
                    offset="95%"
                    stopColor="#f97316"
                    stopOpacity={0}
                  />

                </linearGradient>

              </defs>

              <CartesianGrid
                strokeDasharray="3 3"
              />

              <XAxis
                dataKey="name"
              />

              <YAxis />

              <Tooltip />

              <Area
                type="monotone"
                dataKey="resolved"
                stroke="#f97316"
                fillOpacity={1}
                fill="url(#adminPerfGradient)"
              />

            </AreaChart>

          </ResponsiveContainer>

        </div>

        {/* ================================================
           EFFICIENCY PIE
        ================================================ */}

        <div className="support-panel support-panel--mid">

          <div className="support-panel-header">

            <div>

              <span>
                WORKLOAD HEALTH
              </span>

              <h3>
                Ticket Distribution
              </h3>

            </div>

            <FaBolt />

          </div>

          <ResponsiveContainer
            width="100%"
            height={350}
          >

            <PieChart>

              <Pie
                data={
                  efficiencyPie
                }
                dataKey="value"
                outerRadius={110}
                label
              >

                {efficiencyPie.map(
                  (
                    item,
                    index
                  ) => (

                    <Cell
                      key={index}
                      fill={
                        CHART_COLORS[
                        index
                        ]
                      }
                    />

                  )
                )}

              </Pie>

              <Tooltip />

            </PieChart>

          </ResponsiveContainer>

        </div>

      </div>

      {/* ====================================================
         LOWER GRID
      ==================================================== */}

      <div className="support-panel-grid">

        {/* ================================================
           QUEUE LOAD
        ================================================ */}

        <div className="support-panel support-panel--mid">

          <div className="support-panel-header">

            <div>

              <span>
                QUEUE WORKLOAD
              </span>

              <h3>
                Queue Pressure Matrix
              </h3>

            </div>

            <FaLayerGroup />

          </div>

          <ResponsiveContainer
            width="100%"
            height={330}
          >

            <BarChart
              data={queueLoad}
            >

              <CartesianGrid
                strokeDasharray="3 3"
              />

              <XAxis
                dataKey="name"
              />

              <YAxis />

              <Tooltip />

              <Bar
                dataKey="value"
                fill="#fb923c"
              />

            </BarChart>

          </ResponsiveContainer>

        </div>

        {/* ================================================
           RISK ADMINS
        ================================================ */}

        <div className="support-panel support-panel--mid">

          <div className="support-panel-header">

            <div>

              <span>
                RISK DETECTION
              </span>

              <h3>
                Escalation Risk Admins
              </h3>

            </div>

            <FaBell />

          </div>

          <div className="support-risk-list">

            {lowPerformanceAdmins.map(
              (admin) => (

                <div
                  key={
                    admin.admin_id
                  }
                  className="support-risk-row"
                >

                  <div className="support-risk-left">

                    <div className="support-avatar">

                      <FaExclamationTriangle />

                    </div>

                    <div>

                      <h4>
                        {admin.name}
                      </h4>

                      <p>
                        {
                          admin.queue_name
                        }
                      </p>

                    </div>

                  </div>

                  <div className="support-risk-metrics">

                    <span>

                      <FaArrowDown />

                      {
                        admin.pending
                      }
                      {" "}
                      Pending

                    </span>

                    <span>

                      <FaArrowUp />

                      {
                        admin.resolved
                      }
                      {" "}
                      Resolved

                    </span>

                  </div>

                </div>

              )
            )}

          </div>

        </div>

      </div>

      {/* ====================================================
         TABLE
      ==================================================== */}

      <div className="support-panel1">

        <div className="support-panel-header">

          <div>

            <span>
              ENTERPRISE WORKFORCE MATRIX
            </span>

            <h3>
              Real-Time Admin Performance
            </h3>

          </div>

          <FaUserShield />

        </div>

        <div className="support-table-wrap">

          <table className="support-table">

            <thead>

              <tr>

                <th>
                  Rank
                </th>

                <th>
                  Admin
                </th>

                <th>
                  Queue
                </th>

                <th>
                  Resolved
                </th>

                <th>
                  Pending
                </th>

                <th>
                  Resolution Rate
                </th>

                <th>
                  Avg Hours
                </th>

                <th>
                  SLA Risks
                </th>

              </tr>

            </thead>

            <tbody>

              {rankedAdmins.map(
                (admin) => (

                  <tr
                    key={
                      admin.admin_id
                    }
                  >

                    <td>

                      <span className="support-badge">

                        #{admin.rank}

                      </span>

                    </td>

                    <td>

                      <div className="support-table-user">

                        <div className="support-avatar">

                          <FaStar />

                        </div>

                        <div>

                          <strong>
                            {
                              admin.name
                            }
                          </strong>

                          <span>
                            {
                              admin.email
                            }
                          </span>

                        </div>

                      </div>

                    </td>

                    <td>
                      {
                        admin.queue_name
                      }
                    </td>

                    <td>

                      <span className="support-badge is-sla-safe">

                        {
                          admin.resolved
                        }

                      </span>

                    </td>

                    <td>

                      <span className="support-badge is-normal">

                        {
                          admin.pending
                        }

                      </span>

                    </td>

                    <td>

                      {Number(
                        admin.resolution_rate ||
                        0
                      ).toFixed(1)}
                      %

                    </td>

                    <td>

                      {Number(
                        admin.avg_resolution_hours ||
                        0
                      ).toFixed(1)}
                      h

                    </td>

                    <td>

                      <span className="support-badge is-breached">

                        {
                          admin.sla_breached_open
                        }

                      </span>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}